import React from 'react'
import config from 'config'
import { get } from 'lodash'
import {
  AdventurousJourney,
  AJFiles,
  AJOverview,
  AJPrepAndTrain,
  AJReport
}
from 'containers/pages'
import { Redirect } from 'react-router-dom'

const urlPrefix = `${config.publicPath}/dashboard/awards/:awardId/adventurous-journey/:categoryId/:id`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <AdventurousJourney
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={`${get(props, 'match.params.id')}/overview`} />
        )
      },
      {
        path: `${urlPrefix}/activity`,
        component: props => (
          <AJPrepAndTrain
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/overview`,
        component: props => (
          <AJOverview
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/report`,
        component: props => (
          <AJReport
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/files`,
        component: props => (
          <AJFiles
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      }
    ]
  }
]
